import { RouteEntry } from "../../shared/routes";
import { MeDashboard } from "./MeDashboard";

export const meRoutes: Array<RouteEntry> = [
    { path: '/me', exact: true, component: MeDashboard, authorize: true, },
    { path: '/drivers/home/:profileId', exact: true, component: MeDashboard, authorize: true, },
];
